import { createFileRoute } from "@tanstack/react-router";

import { loadInPlace } from "../data/ensure.ts";
import { useViewer } from "../data/hooks.ts";
import { loadPlanning } from "../planning/loaders.ts";
import { PlanningPending } from "../planning/pending.tsx";
import { PlanningPage } from "../planning/planning-page.tsx";
import { planningSearch, retainPropertyFilter } from "../shell/search.ts";
import { NotFoundPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

const Page = (): ReactElement => {
  const viewer = useViewer();
  return viewer === null ? <NotFoundPage /> : <PlanningPage viewer={viewer} />;
};

// WHY: the period title is the page title, as on the calendar.
export const Route = createFileRoute("/_app/planning/")({
  staticData: { hasPropertyContext: true },
  validateSearch: planningSearch,
  search: retainPropertyFilter(),
  loader: async ({ context, location, cause }) =>
    loadInPlace(cause, async () => loadPlanning(context.data, planningSearch.parse(location.search))),
  pendingComponent: PlanningPending,
  component: Page,
});
